import { useContext } from 'react';
import { Form, Modal } from 'antd';
import { ContextApp } from '../../../../contexts/ContextApp';
import DocumentRender from '../../../../pages/Receipt/components/ModalViewReceipt/components/DocumentRender/DocumentRender';
import useGetDocumentPdf from '../hooks/useGetDocumentPdf';
import './ViewDocumentModal.less';

interface ViewDocumentModalProps {
  state: any;
  onCancel?: () => void;
}

export interface DataType {
  label: string;
  value?: string | null;
}

const ViewDocumentModal = (props: ViewDocumentModalProps) => {
  const { state, onCancel } = props;
  const [form] = Form.useForm();
  const { t } = useContext(ContextApp);
  const { pdfBase64, isPdfLoading } = useGetDocumentPdf({
    documentId: state.data?.id,
  });

  return (
    <Modal
      open={state.open}
      onCancel={onCancel}
      onOk={form.submit}
      okText={t('action.send')}
      title={t('ReceiptTray.viewDocumentModal.title')}
      className="view-document-modal"
      width={1300}
      bodyStyle={{ minHeight: '75vh' }}
      footer={null}
      style={{ overflow: 'hidden' }}
    >
      <DocumentRender pdfBase64={pdfBase64} loading={isPdfLoading} />
    </Modal>
  );
};
export default ViewDocumentModal;
